<div class="topbar-spacer grit-topbar-spacer" #topbarSpacer></div>
<div class="topbar-wrapper grit-topbar-wrapper" #topbarWrapper><ng-content></ng-content></div>
